import { render, staticRenderFns } from "./StuManage.vue?vue&type=template&id=73cd11c6&scoped=true&"
import script from "./stumanage.js?vue&type=script&lang=js&"
export * from "./stumanage.js?vue&type=script&lang=js&"
import style0 from "./StuManage.vue?vue&type=style&index=0&id=73cd11c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cd11c6",
  null
  
)

export default component.exports